import React, { useState } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "./components/Navbar";
import Footer from "./components/FooterSection";
import ChatbotWidget from "./components/ChatbotWidget";

import Home from "./pages/HomePage";
import About from "./pages/About";
import Services from "./pages/Services";
import ServicePage from "./pages/ServicePage";
import Products from "./pages/Products";
import Contact from "./pages/Contact";

import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";

import JibuBot from "./pages/jibubot";
import CreateBlog from "./pages/admin/create-blog";
import Dashboard from "./pages/admin/dashboard";
import Login from "./pages/admin/login";
import NotFound from "./pages/NotFound";

import "./App.css";

/* =====================
   Protected Route
===================== */
const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem("user");

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

/* =====================
   Layout Wrapper
===================== */
const AppLayout = ({ isDarkMode, toggleTheme }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <div className={isDarkMode ? "app dark-mode" : "app light-mode"}>
      {!isAdminRoute && (
        <Navbar isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
      )}

      <main>
        <Routes>
          {/* Public Pages */}
          <Route path="/" element={<Home isDarkMode={isDarkMode} />} />
          <Route path="/about" element={<About isDarkMode={isDarkMode} />} />
          <Route path="/contact" element={<Contact isDarkMode={isDarkMode} />} />

          {/* Services */}
          <Route path="/services" element={<Services isDarkMode={isDarkMode} />} />
          <Route
            path="/services/:serviceName"
            element={<ServicePage isDarkMode={isDarkMode} />}
          />

          {/* Products */}
          <Route path="/products" element={<Products isDarkMode={isDarkMode} />} />
          <Route
            path="/products/:productSlug"
            element={<JibuBot isDarkMode={isDarkMode} />}
          />

          {/* Blog */}
          <Route path="/blog" element={<Blog isDarkMode={isDarkMode} />} />
          <Route
            path="/blog/:slug"
            element={<BlogPost isDarkMode={isDarkMode} />}
          />

          {/* Admin */}
          <Route path="/admin/login" element={<Login />} />

          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/create-blog"
            element={
              <ProtectedRoute>
                <CreateBlog />
              </ProtectedRoute>
            }
          />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <ChatbotWidget />}
    </div>
  );
};

/* =====================
   App Entry
===================== */
function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
  };

  return (
    <HelmetProvider>
      <Router>
        <AppLayout isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
      </Router>
    </HelmetProvider>
  );
}

export default App;
